module.exports = __webpack_public_path__ + "img/pink-shoe.dbaf4375.png";